import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Observable, Subject} from 'rxjs';
import {take} from 'rxjs/operators';
import {BusinessProcess} from '../../../Models/businessProcess';
import {BusinessProcessService} from '../../../services/business-process.service';
import {SecurableObjectType} from '../../../Models/enum/securableObjectType';
import {DropDownContent} from '../../../Models/dropDownContent';
import {AdminService} from '../../../services/admin.service';
import {AccessControlService} from '../../../services/access-control.service';
import {TrusteeType} from '../../../Models/enum/trusteeType';
import {FormsValidatorService} from '../../../services/forms-validator.service';
import {CustomValidator} from '../../../services/custom-validator';
import {GenericModalService} from '../../../services/generic-modal.service';


@Component({
  selector: 'app-access-control-modal',
  templateUrl: './access-control-modal.component.html',
  styleUrls: ['./access-control.component.css', './access-control-modal.component.css']
})
export class AccessControlModalComponent implements OnInit {

  @ViewChild('selectStates', { static: false }) selectElemStates;
  @ViewChild('selectPermissions', { static: false }) selectElemPermissions;
  @ViewChild('selectTrustees', { static: false }) selectElemTrustees;

  @Input() modalTitle: string;

  objId: number; // verificar se a modal foi aberta pela tela de Estado ou Business Process (SecurableObjectType).
  securableObjectAccessForm: FormGroup;
  itemSaved: Subject<boolean>;
  submitted = false;
  error = '';
  pleaseWait = false;

  availableBusinessProcess: Observable<BusinessProcess[]>;
  availableStates: Observable<DropDownContent[]>;
  availableTrustees: Observable<DropDownContent[]>;
  availablePermissions: Observable<DropDownContent[]>;
  availablePermissionsBpList: DropDownContent[];

  bpName: string;
  acesToAppend = [];
  eSecurableObjectType = SecurableObjectType;

  get formData() { return this.securableObjectAccessForm.controls; }

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder, private bpService: BusinessProcessService,
              private admService: AdminService, private accessControl: AccessControlService) {}

  ngOnInit(): void {
    this.createForm();
    this.loadDropdowns();
    this.itemSaved = new Subject();
    if (this.objId === this.eSecurableObjectType.businessProcess) {
      FormsValidatorService.removeValidator(this.securableObjectAccessForm, 'securableObjects');
      FormsValidatorService.removeValidator(this.securableObjectAccessForm, 'permissions');
    }
  }

  createForm() {
    this.securableObjectAccessForm = this.formBuilder.group({
      businessProcessId: [0, CustomValidator.singleDropdown],
      businessProcessName: [[]],
      securableObjects: [[], this.validateMultiSelectDropdown],
      trustees: [[], Validators.required],
      permissions: [[], Validators.required],
      securableObjectType: []
    });
  }

  validateMultiSelectDropdown(input: FormControl) {
    return input.value.length === 0 ? {emptyMultDropDown: true} : null;
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

  onSave() {
    this.submitted = false;

    const securableObjects = this.securableObjectAccessForm.getRawValue();
    securableObjects.securableObjectType = this.objId;

    this.getBusinessProcessName();
    let secObjects = [];
    if (this.objId === this.eSecurableObjectType.businessProcess) {
      securableObjects.securableObjects = [parseFloat(securableObjects.businessProcessId)];
      securableObjects.permissions = this.availablePermissionsBpList.filter(f => {
        return f.id !== 13;
      });
      secObjects.push({ id: securableObjects.businessProcessId, name: this.bpName });

    } else if (this.objId === this.eSecurableObjectType.state) {
      secObjects = this.getSecurableObject();
    }

    this.pleaseWait = true;

    const filter = {
      businessProcessId: securableObjects.businessProcessId,
      businessProcessName: this.bpName,
      securableObjectType: this.objId as SecurableObjectType,
      securableObjects: secObjects,
      users: [],
      groups: [],
      permissions: []
    };

    this.error = '';

    // buscar as permissoes atribuidas
    this.accessControl.getAccessControlEntries(filter)
      .subscribe(result => {
        this.appendEntries(securableObjects, result);
        if (this.acesToAppend.length > 0) {

          // salvar os acessos atribuidos
          this.accessControl.addAccessControlEntries(this.acesToAppend)
            .pipe(take(1))
            .subscribe(
            () => {
              this.submitted = true;
              this.itemSaved.next(true);
              this.pleaseWait = false;
              setTimeout(() => {
                // this.submitted = false;
                this.bsModalRef.hide();
              }, 3000);
            }, error => {
                this.error = error;
                console.error(error);
              });
        } else {
          this.submitted = true;
          this.itemSaved.next(true);
          this.pleaseWait = false;
          setTimeout(() => {
            // this.submitted = false;
            this.bsModalRef.hide();
          }, 2000);
        }
      }, error => {
        this.pleaseWait = false;

        let err = error;
        if (error.indexOf('401') !== -1) {
          err = 'Erro: Sessão expirada.';
        }

        this.error = err;
        console.error(error);
      });
  }

  appendEntries(securableObjects, result) {
    securableObjects.securableObjects.forEach(securableObject => { // foreach Estado / Business Process

      securableObjects.trustees.forEach(trustee => { // Usuário / Grupo

        securableObjects.permissions.forEach(permission => { // Permissoes
          let permissionId = 0;
          if (this.objId === this.eSecurableObjectType.state) {
            permissionId = permission;
          } else {
            permissionId = permission.id;
          }

          const foundACE = result.filter(f => {
            return f.trusteeId === trustee.id &&
              f.trusteeType === trustee.message &&
              f.accessControlPermissionId === permissionId;
          });
          if (foundACE.length === 0) { // se permissao nao foi encontrada na base, devo inseri-la no array

            let aceName = '';
            if (this.objId === this.eSecurableObjectType.state) {
              aceName = this.getPermissionName(permissionId);
            } else {
              aceName = permission.name;
            }

            this.acesToAppend.push({
              trusteeId: trustee.id,
              trusteeType: trustee.message === 'User' ? TrusteeType.user : TrusteeType.group,
              securableObjectId: securableObject,
              securableObjectType: this.objId,
              accessControlPermissionId: permissionId,
              accessControlPermissionName: aceName
            });

          }
        }); // Permissoes - fim

      }); // Usuário / Grupo - fim

    }); // Estado / Business Process - fim
  }

  getSecurableObject() {
    // tratar o array de estados para enviar corretamente para a api
    const arrSecurableObject = [];

    if (this.objId === this.eSecurableObjectType.state) {
      const options = this.selectElemStates.nativeElement.options;
      for (let i = 0; i < options.length; i++) {
        if (options[i].selected) {
          arrSecurableObject.push({ id: options[i].value.split(':')[1].trim(), name: options[i].label});
        }
      }
    }
    return arrSecurableObject;
  }

  getPermissionName(permissionId) {
    const opt = this.selectElemPermissions.nativeElement.options;
    for (let i = 0; i < opt.length; i++) {
      const value = parseFloat(opt[i].value.split(':')[1].trim());
      if (value === permissionId) {
        return opt[i].label;
      }
    }
  }

  loadStates() {
    // limpar a lista de estados para não existir resquicios dos dados anteriores.
    this.securableObjectAccessForm.patchValue({
      securableObjects: []
    });
    this.getBusinessProcessName();
    this.availableStates = this.bpService.getStatesByBusinessProcessName(this.bpName);
  }

  loadDropdowns() {
    this.availableBusinessProcess = this.bpService.getAllBusinessProcesses();
    this.availableTrustees = this.admService.loadDropdownContent('api/accessControl/loadAllTrustees');
    this.availablePermissions = this.accessControl.getSecurableObjectPermissions(this.objId); // objId = SecurableObjectType
    this.availablePermissions.subscribe(res => {
      this.availablePermissionsBpList = res;
    }, error1 => {
      let err = error1;
      if (error1.indexOf('401') !== -1) {
        err = 'Erro: Sessão expirada.';
      }
      console.error(error1);
    });
  }

  getBusinessProcessName() {
    const bp = (document.getElementById('businessProcessModal')) as HTMLSelectElement;
    this.bpName = bp.options[bp.selectedIndex].text;
  }

}
